import React from 'react';
import { closureLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmClosureCumulativeChart(props) {
  const { closure, increment, d0_date, d2_date } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Closure'
      closure={closure}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      closureColor={closureLineColor}
      showArrival={false}
      showClosure={true}
    />
  );
}
